export default __webpack_public_path__ + "static/media/Macarons.ecfa39f2.jpg";